// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1R1pf","list":"styles_list__2n2K1"};